var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M282.9,0H169.7c-31.2,0-56.6,25.3-56.6,56.6v678.9c0,31.2,25.3,56.6,56.6,56.6h113.1c31.3,0,56.6-25.3,56.6-56.6V56.6\n    C339.4,25.3,314.1,0,282.9,0z M622.3,0H509.1c-31.3,0-56.6,25.3-56.6,56.6v678.9c0,31.2,25.3,56.6,56.6,56.6h113.1\n    c31.3,0,56.6-25.3,56.6-56.6V56.6C678.9,25.3,653.5,0,622.3,0z"}));
}

Pause.defaultProps = {"viewBox":"0 0 792 792","height":"1em","width":"1em"};

module.exports = Pause;

Pause.default = Pause;
